export const SET_STEP_ONE_DATA = 'SET_STEP_ONE_DATA';
export const SET_STEP_TWO_DATA = 'SET_STEP_TWO_DATA';

export const SET_IS_FORM_CHANGED = '@user_update/SET_IS_FORM_CHANGED';
export const SET_STEPS_CHANGED = '@user_update/SET_STEPS_CHANGED';

export const SAVE_FORM_DATA_TO_STORAGE = 'SAVE_FORM_DATA_TO_STORAGE';

export const UPDATE_STORE_DATA = 'UPDATE_STORE_DATA';

export const RESET_USER_UPDATE_DATA = 'RESET_USER_UPDATE_DATA';

export const LOAD_USER_DATA = 'LOAD_USER_DATA';
export const LOAD_USER_DATA_FROM_STORAGE = 'LOAD_USER_DATA_FROM_STORAGE';
